import { FormikHelpers } from "formik";
import { useCreateAtmType } from "./api/createAtmType";
import AtmTypeForm from "./AtmTypeForm";


const CreateAtmType = ({handleCloseModal}: CreateTypeProps)  => {
  const createAtmTypeMutation = useCreateAtmType({data: {}});

  const initialValues: IPostNewAtmType = {
    description: "",
    deleted: false
  };

  const handleSubmit = async (values: IPostNewAtmType, { setSubmitting }: FormikHelpers<IPostNewAtmType>): Promise<void> => {
    try {
      await createAtmTypeMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AtmTypeForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreateTypeProps {
  handleCloseModal: () => void;
}

export default CreateAtmType;